export default __webpack_public_path__ + "static/media/cancelOffer.40e1e89f.svg";